import { getAllAccountCodes } from "../api/accountCode";

export const grabAccountCodes = async (): Promise<any> => {
    const apiResults = await getAllAccountCodes();
    console.log(apiResults);
    return apiResults;
};
